// `common/templates/location-auto-complete.tpl.html` — the city / region typeahead.
//
// ⚠️ EVERY ROW IS TWO LINES, AND THE SECOND IS WHAT MAKES THE LIST USABLE. The label is the
// city (or the region when there is no city) and underneath it, in a `<small>`, the region and
// country: "London / Greater London, United Kingdom" against "London / Ontario, Canada".
// Rendering the label alone — which is what the default panel does — gives ten rows reading
// "London" with nothing to choose between them, which is how this looked beside build 354.
//
// ⚠️ AND THE SUBTITLE'S COMMA IS CONDITIONAL. `{{(item.city ? item.region_state + ", " : "")}}{{item.country}}`
// — a row that IS a region shows the country alone, with no leading comma.
//
// The wrap class is `autocomplete company-autocomplete`, which is also what the company field
// uses; the two-line row is the shared part.
import type { ReactElement } from 'react'
import type { SuggestionPanelView } from '../common/TagsInput.tsx'

function subtitle(source: Readonly<Record<string, unknown>> | undefined): string {
  const city = typeof source?.['city'] === 'string' ? source['city'] : ''
  const region = typeof source?.['region_state'] === 'string' ? source['region_state'] : ''
  const country = typeof source?.['country'] === 'string' ? source['country'] : ''
  return `${city !== '' && region !== '' ? `${region}, ` : ''}${country}`
}

export function LocationSuggestionPanel(view: SuggestionPanelView): ReactElement {
  return (
    <div className="autocomplete company-autocomplete">
      <ul className="suggestion-list">
        {view.items.map((tag, index) => (
          <li
            className={`suggestion-item${index === view.highlighted ? ' selected' : ''}`}
            key={`${String(tag.source?.['id'] ?? tag.text)}-${String(index)}`}
            // `mousedown`, not `click`: the input's blur would close the panel first.
            onMouseDown={(event) => {
              event.preventDefault()
              view.onPick(tag)
            }}
            onMouseEnter={() => view.onHighlight(index)}
          >
            <span>{view.highlight(tag.text)}</span>
            <br />
            <small>
              <span>{subtitle(tag.source)}</span>
            </small>
          </li>
        ))}
      </ul>
    </div>
  )
}
